import { useEffect, useState } from 'react'
import { fetchReleaseNotes, type ReleaseNoteEntry } from './releaseNotes'

export interface ReleaseNotesState {
  entries: ReleaseNoteEntry[]
  /** false once the fetch settled, whether or not it found anything */
  loading: boolean
}

/** Fetch the shipped manifest once per mount. Never throws; empty on failure. */
export function useReleaseNotes(): ReleaseNotesState {
  const [state, setState] = useState<ReleaseNotesState>({ entries: [], loading: true })

  useEffect(() => {
    let cancelled = false
    fetchReleaseNotes().then((manifest) => {
      if (cancelled) return
      setState({ entries: manifest?.entries ?? [], loading: false })
    })
    return () => {
      cancelled = true
    }
  }, [])

  return state
}
